// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/message-square.js';

import { paths } from '../generated/message-square';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('message-square', Original, paths);
